import { getBackendUrl } from './backend';

export function getWebSocketUrl(path: string): string {
  const url = new URL(getBackendUrl());
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.pathname = path.startsWith('/') ? path : `/${path}`;
  url.search = '';
  url.hash = '';

  return url.toString();
}
